export interface CredentialsManagerGridSchema {
  _id: string;
  username: string;
  password: string;
  description: string;
  isPem: boolean;
  type: number;
  specifics?: object;
  userId?: string;
}

export interface CredentialsManagerCreateRequest {
  username: string;
  password: string;
  description: string;
  isPem: boolean;
  type: number;
  pem?: File;
}

export interface CredentialsManagerReadResponse {
  success: boolean;
  data: Array<CredentialsManagerGridSchema>;
  total: number;
}

export interface CredentialsManagerCreateResponse {
  success: boolean;
}

export interface UploadFileResponse {
  success: boolean;
  message: string;
}

export interface CredentialsManagerFormValue {
  credentials: Array<string>;
}

export enum Column {
  USER,
  PASSWORD,
  DESCRIPTION,
  ACTIONS,
}

export enum ColumnKeys {
  USER = 'username',
  PASSWORD = 'password',
  DESCRIPTION = 'description',
  ACTIONS = 'actions',
}

export interface DataGridItemsResponse {
  rawEvents: Array<DataGridItem>;
  success: boolean;
}

export interface DataGridItem {
  username: string;
  password: string;
  isPem: boolean;
  type: number;
  description?: string;
  actions?: string;
}

export interface CredentialGridData {
  authTypes: Array<AuthTypesData>;
}

export enum CredentialsManagerEvents {
  OnDeleteCredential = 'deleteCredential',
}

export enum AUTH_VALUES {
  PASSWORD = 1,
  PEM_FILE = 2,
}

export interface AuthTypesData {
  value: number;
  title: string;
}

export enum CREDENTIALS {
  CREDENTIAL_TYPE_MACHINE = 0,
}
export const pageSizeOptions = [
  {
    title: '20',
    value: '20',
  },
  {
    title: '50',
    value: '50',
  },
  {
    title: '100',
    value: '100',
  },
];

export const PEM_SIZE_LIMIT_KB = 50;

export const MAX_FILE_SIZE = 50000;
